import { render, staticRenderFns } from "./DingDing.vue?vue&type=template&id=54aa3963&scoped=true"
import script from "./DingDing.vue?vue&type=script&lang=js"
export * from "./DingDing.vue?vue&type=script&lang=js"
import style0 from "./DingDing.vue?vue&type=style&index=0&id=54aa3963&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa3963",
  null
  
)

export default component.exports